const merchandizingSets = {
    Merchandizing_Sets: 'Merchandizing Sets',
    CreateSets : 'Create Sets',
    CreateDisplays: 'Create Displays',
    AddImages: 'Add Images',
    FinalEnrolledListHeader: 'Upload Enrolled Outlets',
    UploadOutletList: 'Upload Outlet list',
    UploadOutletListforN: 'Upload Outlet list for ',
    FinalApprovedOutlets: 'Final Approved Outlets',
    MS_Update_Modal_Sub_Title: 'Please upload filled CSV with Updated Status',
    UploadMSSuccess:  "Merchandizing Set Updated successfully.",
    MS_Upload_Image: 'Add Images',
    MS_Upload_ZipFile: 'Please upload filled zip folder to upload images',
    MS_Image_Modal_Sub_Title: 'Upload zip folder containing images',
    MS_Image_Modal_Title: 'Upload merchandizing display images',
    MS_Accepted_image_format: ' Zip',
    Upload_Modal_CTA_Text: "Upload",
    MaxImageFile: '100MB',
    UploadErrors: "Upload Error",
    InvalidFormatMsg: "Some of the images follow invalid format",
    InvalidDisplayIdMsg: "Some images have unknown Display IDs",
    OnlyZipAllowed: "Only .zip files are allowed.",
    ZipReadError: "Could not read zip file. Try again.",
    InvalidZipContents: "Some of the images names are invalid.",
    MaxZipSizeExceeded: "The file size exceeds 100 MB.",
    Delete_Modal_Text: "Confirm Set Deletion",
    Delete_Modal_SubText: "You are deleting set, Are you sure you want to delete ?",
    Confirm_CTA: 'Confirm',
    Cancel_CTA: 'Cancel',
    Delete_Success: "Deleted successfully",
    Delete_Error: "Cannot be deleted due to error. Please try again",
    UploadDisplaySuccess: "Display Task Updated successfully",
    UploadOutletSuccess: "Outlet List Updated successfully",
    UploadMSImageSuccess:  "Images Uploaded successfully.",
    Pause_Modal_Sub_Text: "Are you sure you want to Pause enrollment ?" ,
    Resume_Modal_Sub_Text: "Are you sure you want to Un-Pause enrollment ?",
    Pause_Modal_Text: "Confirm Pause",
    Resume_Modal_Text: "Confirm Un-Pause",
    Downloading: "Downloading",
    UploadEnrolledOutlets: "Upload Enrolled Outlets",
    UploadPOSMSuccess: "POSM uploaded successfully",
    UploadPOSMError: "POSM upload failed due to error. Kindly try again",
    Upload_POSM: 'Upload POSM',
    DownloadPosmlist: "Download POSM list",
    Downloadlast3monthResult: "Download last 3 month Result",
    AddOutletList: "Add Outlet List",
    UploadImage: "Upload Image",
    PosmConfiguration: "POSM Configuration",
    Upload_merchandizing_POSM_images: "Upload merchandizing POSM images",
    SurveyConfiguration: "Survey Configuration",
    DownloadOutletList: "Download Outlet list",
    DownloadSosOutletList: "Download Current Outlet list",
    UploadSurveySuccess: "Survey uploaded successfully",
    UploadSurveyError: "Survey upload failed due to error. Kindly try again",
    Upload_Survey: 'Upload Survey',
    UpdateSurveySuccess: "Survey updated successfully",
    SurveyUploadLimit:  "Maximum 10 surveys allowed. Please delete a survey to add a new one.",
    EditSurveyName: "Edit Name",
    SurveyName: "Survey Name",
    SurveyNameAlreadyExists: "Name already exists for another survey",
    PosmL3MReport: "POSM L3M Report",
    SurveyL3MReport: "Survey L3M report",
    UploadPosmMapSet_Success: "Map set uploaded successfully ",
    Upload_MapSet: "Upload Map Set",
    MapSet: "Map Set",
    SOSConfiguration: "SOS Configuration",
    UploadCategoryList: "Upload Category List",
    ReuploadCategoryList: "Re-upload Category List",
    UploadSosSuccess: "Category List uploaded successfully",
    UpdateSosSuccess: "Category List Updated successfully",
    OkLabel: "OK",
    AllLabel: "ALL",
    SosUploadLimit: "Maximum 5 category list allowed. Please delete a category list to add a new one.",
    SosL3MReport: "SOS L3M report",
    CategoryNameAlreadyExists: "Name already exists for another category list",
    DownloadSets: "Download Sets",
    DownloadOutletEnrollment: "Download Outlet Enrollment",
    DownloadLast3MonthsCoachingResults: "Download last 3 months coaching results",
    CoachingL3MReport: "Coaching L3M report",
    Configure: "Configure",
    ShowConfigure: "Show Configure",
    HideConfigure: "Hide Configure",
    BuildSets: "Build sets",
    UploadEligibleOutlets: "Upload eligible outlets",
    LiveStep: "Live",
    LiveStepMessage: "Your merchandising sets are live for this month.",
    StepCompleteMessage: "This step is complete for this period.",
    TodayLabel: "Today- ",

};
export default merchandizingSets
